import { userLanguage } from '@glow/common/utils/language'
import { siteMetricsCaptureErrorMessage } from '@glow/instrumentation'
import { setup } from '@glow/language'
import i18n from 'i18next'
import { Settings } from 'luxon'
import en from './en'

// English is every language's fallback, so it comes with the app. The other languages arrive on demand
const catalogues = new Map<string, () => Promise<{ default: object }>>([
  ['sv', () => import('./sv')],
  ['nb', () => import('./nb')],
  ['dk', () => import('./dk')],
  ['fi', () => import('./fi')],
  ['fr', () => import('./fr')]
])

setup()
// Here rather than where dates are formatted: modules that load at startup run before this one, while i18next has no
// language yet
Settings.defaultLocale = userLanguage()
i18n.addResourceBundle('en', 'translation', en)

export const loadLanguages = async (codes: readonly string[]): Promise<void> => {
  await Promise.all(
    codes.map(async (code) => {
      const load = catalogues.get(code)
      if (load === undefined) {
        return
      }
      try {
        i18n.addResourceBundle(code, 'translation', (await load()).default)
      } catch (error) {
        // A language that fails to arrive leaves English, as for a language Glow doesn't have. Trying again would most
        // likely fail too: the browser remembers a module that failed to load
        siteMetricsCaptureErrorMessage(`The ${code} texts did not load, so the app shows English`, {
          tags: { language: code },
          extra: { error: String(error) }
        })
      }
    })
  )
}

// The user's language, which i18next has picked by now. Choosing another one reloads the page
export const userLanguageLoaded = loadLanguages(i18n.languages)
